// GA Event - LiveChat

jQuery(document).ready(function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'LiveChat',
    });
});

// GA Event - Page Scrolling

/*
document.addEventListener('scroll', function(){
    var h =  document.documentElement,
        b =  document.body,
        st =  'scrollTop',
        sh =  'scrollHeight';
    var percent = parseInt ( (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100);
    //console.log(percent + "%");
    if (percent == 25) {
        window.dataLayer.push({
            'event': 'scrolledMorethan25%',
        });
    } else if (percent == 50) {
        window.dataLayer.push({
            'event': 'scrolledMorethan50%',
        });
    } else if (percent == 75) {
        window.dataLayer.push({
            'event': 'scrolledMorethan75%',
        });
    } else if (percent == 90) {
        window.dataLayer.push({
            'event': 'scrolledMorethan90%',
        });
    }
});
*/

// GA Event - External Link Click
var hostname = window.location.hostname; 
jQuery("body a").on('click', function(){
    url = jQuery(this).attr('href');
    urlParts = /^(?:\w+\:\/\/)?([^\/]+)(.*)jQuery/.exec(url);
    hostnameLink = urlParts[1];
    window.dataLayer = window.dataLayer || [];
    if ( jQuery(this).attr("href").indexOf(hostname)== -1 && !hostnameLink.indexOf('facebook')== -1 && !hostnameLink.indexOf('instagram')== -1 ) {
        if(jQuery(this).attr("href").indexOf(hostname)== -1){
            window.dataLayer.push({
                'event': 'ExternalLinkClick',
                'hostname': hostname,
            });
        }
    }
});

// GA Event - Social Link Click
jQuery('.socials .social a').on('click', function(){
    url = jQuery(this).attr('href');
    urlParts = /^(?:\w+\:\/\/)?([^\/]+)(.*)jQuery/.exec(url);
    hostname = urlParts[1];
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'SocialLinkClick',
        'hostname': hostname,
    });
});